import { atom } from 'jotai'

import { atomWithPartialUpdate, getCurrentChainIdFromUrl } from '@cowprotocol/common-utils'
import { SupportedChainId, ChainInfo } from '@cowprotocol/cow-sdk'

interface TokensModuleEnvironment {
  chainId: SupportedChainId
  enableLpTokensByDefault?: boolean
  hideFavoriteTokens?: boolean
  isYieldEnabled?: boolean
  excludeRwaLists?: boolean
  widgetAppCode?: string
  selectedLists?: string[]
  sellSelectedLists?: string[]
  buySelectedLists?: string[]
  bridgeNetworkInfo?: ChainInfo[]
}

// TODO: Why do we have this? Read it directly from URL => atom
export const { atom: environmentAtom, updateAtom: updateEnvironmentAtom } = atomWithPartialUpdate(
  atom<TokensModuleEnvironment>({
    chainId: getCurrentChainIdFromUrl(),
  }),
)
